import '../../components/mobileStyles.scss'

import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Drawer } from 'antd'

import { ChevronRightIcon, CloseIcon } from '@/components/Icons'
import HeaderLogoSection from '@/components/Layout/Header/components'
import BackButton from '@/components/Layout/Header/Submenu/Mobile/components/BackButton'
import { useAppDispatch } from '@/store/hook'
import { setSelectedMachineInfo } from '@/store/slices/serviceCaseSlice'
import { SERVICE_ENTRY } from '@/libs/constants'
import { linkGenerator } from '@/libs/utils/language'

import ServiceItem from './ServiceItem'
import ServiceTitle from './ServiceTitle'

const ServiceSubmenuMobile = (props) => {
  const { btnName: buttonName = '', onClose, onFocusSearch } = props
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const [isShowServices, setShowServices] = useState(false)

  const closeDrawer = useCallback(() => {
    onClose()
    setShowServices(false)
  }, [onClose])

  const handleRequestService = useCallback(
    (serviceEntry, path) => {
      dispatch(
        setSelectedMachineInfo({
          serviceEntry,
          isChangedService: true,
        }),
      )
      closeDrawer()
      navigate(linkGenerator(path))
    },
    [dispatch, navigate, closeDrawer],
  )

  const serviceRequests = [
    {
      name: t('service.headerMenu.requestRepair'),
      handleClick: handleRequestService,
      serviceEntry: SERVICE_ENTRY.REPAIR,
    },
    {
      name: t('service.headerMenu.requestMaintenance'),
      handleClick: handleRequestService,
      serviceEntry: SERVICE_ENTRY.MAINTENANCE,
    },
  ]

  const handleBackButtonClick = useCallback(() => setShowServices(false), [])

  const handleServicePackagesButtonClick = useCallback(() => {
    navigate(linkGenerator('/service/service-packages'))
  }, [navigate])

  const renderServicesDrawer = () => (
    <Drawer // Product Categories Drawer (with 2 items Accessories & Detergents at the end)
      closable
      closeIcon={<CloseIcon />}
      open={isShowServices}
      placement="right"
      rootClassName="header-menu-drawer header-menu-drawer__sub-drawer"
      width={window.innerWidth}
      title={
        <HeaderLogoSection
          inBurgerMenu
          onFocusSearch={onFocusSearch}
          onHideDrawerMobile={onClose}
        />
      }
      onClose={closeDrawer}
    >
      <BackButton
        name={t('header.drawer.button.back')}
        onClick={handleBackButtonClick}
      />
      <ServiceTitle
        name={t('pageTitle.servicePackages')}
        onClick={handleServicePackagesButtonClick}
      />
      <ServiceTitle name={t('createServiceRequest')} />
      {serviceRequests.map(({ name, handleClick, path, serviceEntry }) => (
        <ServiceItem
          key={`${name} + ${path}`}
          name={name}
          path={path}
          serviceEntry={serviceEntry}
          onClick={handleClick}
        />
      ))}
    </Drawer>
  )

  return (
    <div className="submenu-mobile">
      <button
        className="submenu-mobile__btn"
        type="button"
        onClick={() => setShowServices(true)}
      >
        {buttonName}
        <ChevronRightIcon />
      </button>
      {renderServicesDrawer()}
    </div>
  )
}

export default ServiceSubmenuMobile
